import { ZiroLink } from '../shared/models/ziro-link';

export const zpcProxyServerAdminLinks: ZiroLink[] = [
  {
    url: '/admin/license',
    label: 'tkey;menu.admin.license',
    automation: 'menu-license-link',
    isRouterLink: true,
  },
  {
    url: '/admin/system-health-status',
    label: 'tkey;system_status.title',
    automation: 'menu-system-health-status-link',
    isRouterLink: true,
  },
  {
    url: '/admin/proxy-server-management/zpm-connection-settings',
    label: 'tkey;admin.proxy_server_management.zpm_connection_settings.title',
    automation: 'menu-proxy-server-connection-settings-link',
    isRouterLink: true,
  },
  {
    url: '/admin/proxy-server-management/proxy-feature-settings',
    label: 'tkey;admin.proxy_server_management.proxy_feature_settings.title',
    automation: 'menu-proxy-feature-settings-link',
    isRouterLink: true,
  },
  {
    url: '/admin/ldap-management',
    label: 'tkey;admin.ldap.title',
    automation: 'menu-ldap-link',
    isRouterLink: true,
  },
  {
    url: '/admin/servers',
    label: 'tkey;admin.servers.config.title',
    automation: 'menu-servers-link',
    isRouterLink: true,
  },
  {
    url: '/admin/certificate-management',
    label: 'tkey;admin.certificate_management.title',
    automation: 'menu-certificate-management-link',
    isRouterLink: true,
  },
  {
    url: '/admin/application-logs',
    label: 'tkey;menu.admin.application_logs',
    automation: 'application-logs-link',
    isRouterLink: true,
  },
  {
    url: '/admin/backup',
    label: 'tkey;admin.backup.title',
    automation: 'menu-backups-link',
    isRouterLink: true,
  },
  {
    url: '/admin/db-import',
    label: 'tkey;pages.admin.import.title',
    automation: 'menu-config-import-link',
    isRouterLink: true,
  },
];
